import { Component, OnInit, Input } from "@angular/core"
import { Router } from "@angular/router"
import { Location } from "@angular/common"
import { KapraoService } from "../../../services/kaprao.service"
import { MessageService } from "../../../services/login.service"
import * as packageInfo from "../../../../package.json"

@Component({
    selector: "app-sidenav",
    templateUrl: "./sidenav.component.html",
    styleUrls: ["./sidenav.component.scss"],
})
export class SidenavComponent implements OnInit {
    @Input() userProfile
    tab_active
    access
    sm
    t
    m = []
    subM = []
    version
    oddInteval
    counter = 0
    constructor(
        private messageService: MessageService,
        private router: Router,
        private service: KapraoService,
        private location: Location
    ) {}

    ngOnInit(): void {
        let a = packageInfo
        let v = a.version.split("-")
        this.version = v[0]
        this.access = JSON.parse(localStorage.getItem("p"))
        this.sm = JSON.parse(localStorage.getItem("sm"))
        this.t = JSON.parse(localStorage.getItem("m"))
        this.t.forEach((m) => {
            this.m.push(m.code)
            m.subMenu.forEach((sm) => {
                this.subM.push(sm.code)
            })
        })
        console.log(this.m)
        console.log(this.subM)
        console.log(this.t.filter((d) => d.code == "DASHBOARD").length > 0)
        console.log(this.m.indexOf("DASHBOARD") > -1)
        this.tab_active = this.location.path()
        console.log(this.tab_active)
        // this.getProfile
    }
    // getProfile() {
    //   console.log("getprofile");
    //   this.service.getProfile().then((res: any) => {
    //     console.log(res.data);
    //     this.userProfile = (({ isSupport, username, position }) => ({
    //       isSupport,
    //       username,
    //       position,
    //     }))(res.data);
    //     console.log(this.userProfile);
    //   });
    // }
    checkPermission(p) {
        console.log(p)
        return this.t.filter((d) => d.code == p).length > 0
    }
    logout() {
        localStorage.clear()
        this.messageService.sendMessage("logout")
        this.router.navigate(["login"])
    }
    toggleSidenav() {}
    checkV() {
        this.router.navigate(["change-log"])
    }
}
